exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.email-test[data-v-5101379c] {\n  padding: 12px;\n}\n", ""]);

// exports
